/* eslint-disable react/prop-types */
import { Grid, MenuItem, Select } from "@mui/material";
import Loading from "components/Loading";
import ModalUI from "components/ModalUI";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import React, { useState } from 'react'
import { toast } from "react-toastify";
import { addGhollakProfitProcess } from "services/ghollak.routes";
import errorHandler from "utils/errorHandler";
import renderInputField from "utils/renderInputField";

export default function GhollakProfitProcessModal({ modalInfo, closeModal }) {
  const [information, setInformation] = useState({})
  const [loading, setLoading] = useState(false)
  const handleChange = (event) => {
    const { name, value } = event.target;
    setInformation({ ...information, [name]: value });
  };

  const submitProfitProcess = () => {
    setLoading(true);
    const data = {
      ...information,
      ghollak_min_balance_id: modalInfo.minBalanceIds
    }
    addGhollakProfitProcess(data, (isOk, data) => {
      setLoading(false);
      if (!isOk) {
        if (data.errors)
          return errorHandler(data.errors)
        else return toast.error(data.message)
      } else {
        toast.success('عملیات با موفقیت انجام شد');
        closeModal()
      }
    })
  }
  return (
    <ModalUI open={modalInfo.state} handleClose={closeModal} style={{ minWidth: "600px" }}>
      <Loading loading={loading} />
      <SoftBox component="form" role="form">
        <Grid container spacing={3}>
          {[
            { label: "عملیات", name: "operation", options: [{ value: "100", label: "محاسبه شده" }, { value: "101", label: "ارسال برای پرداخت" }, { value: "102", label: "پرداخت شده" }] },
          ].map((selectField, index) => (
            <Grid item xs={12} sm={6} xl={6} key={index}>
              <SoftBox mb={1} ml={0.5}>
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  {selectField.label}
                </SoftTypography>
              </SoftBox>
              <Select name={selectField.name} value={String(information[selectField.name])} onChange={handleChange} fullWidth>
                {selectField.options.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          ))}
          {[
            { label: "سود", name: "rate", type: "text", placeholder: "بین 0و1", value: information.rate },
            { label: "سهم کاربر", name: "user_cut", type: "text", placeholder: "بین 0و1", value: information.user_cut },
            { label: "سهم پلتفرم", name: "platform_cut", type: "text", placeholder: "بین 0و1", value: information.platform_cut },
          ].map((field) => renderInputField(field.name, field.label, field.type, field.placeholder, information, handleChange, 6))}
        </Grid>
        <SoftButton onClick={submitProfitProcess} style={{ marginTop: 20 }} variant="gradient" color="info">
          ثبت
        </SoftButton>
      </SoftBox>
    </ModalUI>
  )
}
